import { render, staticRenderFns } from "./IconMiddleTop.vue?vue&type=template&id=2cb4acde&"
import script from "./IconMiddleTop.vue?vue&type=script&lang=js&"
export * from "./IconMiddleTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cb4acde')) {
      api.createRecord('2cb4acde', component.options)
    } else {
      api.reload('2cb4acde', component.options)
    }
    module.hot.accept("./IconMiddleTop.vue?vue&type=template&id=2cb4acde&", function () {
      api.rerender('2cb4acde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/PopupButtonPositions/IconMiddleTop.vue"
export default component.exports